import { render } from "./NewsFlash.vue?vue&type=template&id=366d3c90"
import script from "./NewsFlash.vue?vue&type=script&lang=ts"
export * from "./NewsFlash.vue?vue&type=script&lang=ts"

import "./NewsFlash.vue?vue&type=style&index=0&id=366d3c90&lang=scss"
script.render = render

export default script